var _a;
const CONTENT_TYPE_URL_ENCODED = 'application/x-www-form-urlencoded';
const CONTENT_TYPE_FORM_DATA = 'multipart/form-data';
const u = up.util;
up.Request.XHRRenderer = (_a = class XHRRenderer {
        constructor(request) {
            this._request = request;
        }
        buildAndSend(handlers) {
            const xhr = this._request.xhr;
            this._params = u.copy(this._request.params);
            if (this._request.timeout) {
                xhr.timeout = this._request.timeout;
            }
            xhr.open(this._getMethod(), this._request.url);
            let contentType = this._getContentType();
            if (contentType) {
                xhr.setRequestHeader('Content-Type', contentType);
            }
            for (let headerName in this._request.headers) {
                let headerValue = this._request.headers[headerName];
                xhr.setRequestHeader(headerName, headerValue);
            }
            Object.assign(xhr, handlers);
            xhr.send(this._getPayload());
        }
        _getMethod() {
            let method = this._request.method;
            if (this._request.wrapMethod && !this._request.will302RedirectWithGET()) {
                method = up.protocol.wrapMethod(method, this._params);
            }
            return method;
        }
        _getContentType() {
            this._finalizePayload();
            return this._contentType;
        }
        _getPayload() {
            this._finalizePayload();
            return this._payload;
        }
        _finalizePayload() {
            this._payload = this._request.payload;
            this._contentType = this._request.contentType;
            if (!this._payload && this._request.allowsPayload()) {
                if (!this._contentType) {
                    this._contentType = this._params.hasBinaryEntries() ? CONTENT_TYPE_FORM_DATA : CONTENT_TYPE_URL_ENCODED;
                }
                if (this._contentType === CONTENT_TYPE_FORM_DATA) {
                    this._contentType = null;
                    this._payload = this._params.toFormData();
                }
                else {
                    this._payload = this._params.toQuery().replace(/%20/g, '+');
                }
            }
        }
    },
    (() => {
        u.memoizeMethod(_a.prototype, {
            _finalizePayload: true,
            _getMethod: true,
        });
    })(),
    _a);
